import { Link } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { IconUser } from '@/components/icons/Icons'
import './Header.css'

function Header() {
  const { language } = useLanguage()
  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo">
          <h1>Dreamity</h1>
          <span className="header__logo-sub">Planner</span>
        </Link>
        <div className="header__actions">
          <Link to="/user" className="header__link header__link--user" title={language === 'ko' ? '사용자 정보' : 'Account'}>
            <span className="header__icon header__icon--user">
              <span className="header__icon-inner"><IconUser size={20} /></span>
            </span>
            <span className="header__link-label">{language === 'ko' ? '사용자 정보' : 'Account'}</span>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header


